var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUpload = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "black",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 75.3822C59.1875 75.3822 58.5156 75.1115 57.9844 74.5701C57.4531 74.0287 57.1875 73.3439 57.1875 72.5159V39.9363L47.9062 49.3949C47.3437 49.9682 46.6875 50.2389 45.9375 50.207C45.1875 50.1752 44.5312 49.8726 43.9688 49.2994C43.4062 48.7261 43.125 48.0414 43.125 47.2452C43.125 46.449 43.4062 45.7643 43.9688 45.1911L58.0313 30.8599C58.3438 30.5414 58.6563 30.3185 58.9688 30.1911C59.2813 30.0637 59.625 30 60 30C60.375 30 60.7187 30.0637 61.0312 30.1911C61.3437 30.3185 61.6562 30.5414 61.9687 30.8599L76.125 45.2866C76.6875 45.8599 76.9688 46.5287 76.9688 47.293C76.9688 48.0573 76.6875 48.7261 76.125 49.2994C75.5625 49.8726 74.8906 50.1592 74.1094 50.1592C73.3281 50.1592 72.6562 49.8726 72.0938 49.2994L62.8125 39.9363V72.5159C62.8125 73.3439 62.5469 74.0287 62.0156 74.5701C61.4844 75.1115 60.8125 75.3822 60 75.3822ZM35.625 90C34.125 90 32.8125 89.4267 31.6875 88.2803C30.5625 87.1338 30 85.7962 30 84.2675V73.4713C30 72.6433 30.2656 71.9586 30.7969 71.4172C31.3281 70.8758 32 70.6051 32.8125 70.6051C33.625 70.6051 34.2969 70.8758 34.8281 71.4172C35.3594 71.9586 35.625 72.6433 35.625 73.4713V84.2675H84.375V73.4713C84.375 72.6433 84.6406 71.9586 85.1719 71.4172C85.7031 70.8758 86.375 70.6051 87.1875 70.6051C88 70.6051 88.6719 70.8758 89.2031 71.4172C89.7344 71.9586 90 72.6433 90 73.4713V84.2675C90 85.7962 89.4375 87.1338 88.3125 88.2803C87.1875 89.4267 85.875 90 84.375 90H35.625Z",
    fill: "black",
    fillOpacity: 0.87
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUpload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/upload.6edc2401725390c4c0edeac3ff95b378.svg";